// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"259":"7f3e6873","487":"781f9d2c"}[chunkId] + ".css";
};